// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSliderArrow_root__3_KUo","arrow":"IconSliderArrow_arrow__1dY1P"};